/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AddressCountryEnum } from './addressCountryEnum';
import { AttendanceEndCodeEnum } from './attendanceEndCodeEnum';
import { AttendanceFulfillmentMethodEnum } from './attendanceFulfillmentMethodEnum';
import { AttendanceStartCodeEnum } from './attendanceStartCodeEnum';
import { BlankEnum } from './blankEnum';
import { ChildProfileAddressCreate } from './childProfileAddressCreate';
import { DisabilityTypeEnum } from './disabilityTypeEnum';
import { DisadvantagesEnum } from './disadvantagesEnum';
import { EducationCourseChoiceEnum } from './educationCourseChoiceEnum';
import { GenderEnum } from './genderEnum';
import { InsuranceCompanyEnum } from './insuranceCompanyEnum';
import { LevelOfTalentEnum } from './levelOfTalentEnum';
import { MeasureLevelEnum } from './measureLevelEnum';
import { NationalityQualifierEnum } from './nationalityQualifierEnum';
import { NullEnum } from './nullEnum';
import { SocialCategoryDisadvantageA61Enum } from './socialCategoryDisadvantageA61Enum';

export interface ChildProfileCreate { 
    firstName: string;
    lastName: string;
    nickname?: string;
    idCode?: string;
    gender: GenderEnum;
    birthDate: string;
    birthPlace?: string;
    birthNumber?: string;
    nationalityQualifier?: NationalityQualifierEnum | NullEnum;
    nationality?: AddressCountryEnum | BlankEnum | NullEnum;
    insuranceCompany?: InsuranceCompanyEnum | NullEnum;
    gdprConsent?: boolean;
    importantNote?: string;
    attendanceStart?: string;
    attendanceEnd?: string;
    attendanceStartCode?: AttendanceStartCodeEnum | NullEnum;
    attendanceEndCode?: AttendanceEndCodeEnum | NullEnum;
    attendanceFulfillmentMethod?: AttendanceFulfillmentMethodEnum | NullEnum;
    educationCourseChoice?: EducationCourseChoiceEnum | NullEnum;
    socialCategoryDisadvantage?: SocialCategoryDisadvantageA61Enum | NullEnum;
    isHealthDisadvantaged?: boolean;
    disadvantages?: Array<DisadvantagesEnum | NullEnum>;
    measureLevel?: MeasureLevelEnum | NullEnum;
    ignoranceOfLanguage?: boolean;
    levelOfTalent?: LevelOfTalentEnum | BlankEnum | NullEnum;
    primaryClass?: string;
    addresses?: Array<ChildProfileAddressCreate>;
    disabilityType?: DisabilityTypeEnum | BlankEnum | NullEnum;
    hasHeavyDisability?: boolean;
    setGroups?: Array<string>;
    /**
     * msmt export field
     */
    visaLabel?: string;
    /**
     * msmt export field
     */
    idZnev?: string;
    socialDisadvantageCode?: string;
}